var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    clipPath: "url(#clip0_684_15784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.125 9.375L12 3.25C11.7918 3.03979 11.5153 2.91085 11.2204 2.88641C10.9256 2.86196 10.6317 2.94362 10.3917 3.11667L7.64167 5.075C7.41648 5.22871 7.1472 5.30457 6.87489 5.29103C6.60258 5.27749 6.34217 5.17529 6.13333 5L0.625 0.625",
    stroke: "#FF8053",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 9.375H18.125V4.375",
    stroke: "#FF8053",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16.0415H1.25C0.904822 16.0415 0.625 16.3213 0.625 16.6665V18.7498C0.625 19.095 0.904822 19.3748 1.25 19.3748H7.5C7.84518 19.3748 8.125 19.095 8.125 18.7498V16.6665C8.125 16.3213 7.84518 16.0415 7.5 16.0415Z",
    stroke: "#FF8053",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 16.0415H11.25C10.9048 16.0415 10.625 16.3213 10.625 16.6665V18.7498C10.625 19.095 10.9048 19.3748 11.25 19.3748H17.5C17.8452 19.3748 18.125 19.095 18.125 18.7498V16.6665C18.125 16.3213 17.8452 16.0415 17.5 16.0415Z",
    stroke: "#FF8053",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 12.7085H12.5C12.1548 12.7085 11.875 12.9883 11.875 13.3335V15.4168C11.875 15.762 12.1548 16.0418 12.5 16.0418H18.75C19.0952 16.0418 19.375 15.762 19.375 15.4168V13.3335C19.375 12.9883 19.0952 12.7085 18.75 12.7085Z",
    stroke: "#FF8053",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 12.7085H2.5C2.15482 12.7085 1.875 12.9883 1.875 13.3335V15.4168C1.875 15.762 2.15482 16.0418 2.5 16.0418H8.75C9.09518 16.0418 9.375 15.762 9.375 15.4168V13.3335C9.375 12.9883 9.09518 12.7085 8.75 12.7085Z",
    stroke: "#FF8053",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.375H1.25C0.904822 9.375 0.625 9.65482 0.625 10V12.0833C0.625 12.4285 0.904822 12.7083 1.25 12.7083H7.5C7.84518 12.7083 8.125 12.4285 8.125 12.0833V10C8.125 9.65482 7.84518 9.375 7.5 9.375Z",
    stroke: "#FF8053",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_684_15784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHIcon5);
export default __webpack_public_path__ + "static/media/hIcon5.313e3a58e6eb4d42b6cf43a8f94f0b67.svg";
export { ForwardRef as ReactComponent };